import React, { useState, useEffect } from "react";
//import Select from "react-select";
import AddGlModal from "../modal/AddGlModal";
import api from "../../api/axios";
import SearchableSelect from "../common/SearchableSelect";


function TransactionForm({ entry=null, onSubmit, errorMsg }) {
  let currentDate = new Date().toISOString().split("T")[0];
  const [voucherDate, setVoucherDate] = useState(currentDate);
  const [series_no, setSeries_no] = useState("");  
  const [narration, setNarration] = useState("");
  const [segment, setSegment] = useState(null);
  const [currency, setCurrency] = useState({ value: "QAR", label: "QAR" });
  const [reference, setReference] = useState([]);
  const [loadSegments, setLoadSegments] = useState([]);  
  const [billNo, setBillNo] = useState("");
  const [billDate, setBillDate] = useState(currentDate);
  const [editReason, setEditReason] = useState("");
  const [activeRowIndex, setActiveRowIndex] = useState(null);

  const token = localStorage.getItem("accessToken");

  const [entries, setEntries] = useState([
    { glAccount: null, description: "", debit: "", credit: "" },
    { glAccount: null, description: "", debit: "", credit: "" },
  ]);

  const [glAccounts, setGlAccounts] = useState(null);
  const [showGlModal, setShowGlModal] = useState(false);

  const loadFormData = async () => {
    try {
      let branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;
      const res = await api.get("/load-transaction-form-data/"+branch_id, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Always load GL accounts + segments
      const loadedGlAccounts = res.data.glAccounts.map(acc => ({
        value: acc.ledger_id,
        label: `${acc.ledger_code} - ${acc.ledger_name}`,
      }));

      const loadedSegments = res.data.segments.map(seg => ({
        value: seg.id,
        label: `${seg.ledger_code} - ${seg.ledger_name}`,
      }));

      setGlAccounts(loadedGlAccounts);
      setLoadSegments(loadedSegments); 

      // ---- If creating new ----
      if (!entry) {
        //setVoucherDate(currentDate);
        setSeries_no(res.data.next_ref_no);
        //setCurrency({ value: "QAR", label: "QAR" });
        //setReference([]);
        setEntries([
          { glAccount: null, description: "", debit: "", credit: "" },
          { glAccount: null, description: "", debit: "", credit: "" },
        ]);
        return;
      }

      // ---- If editing ----
      setVoucherDate(entry.voucher_date || currentDate);
      setSeries_no(entry.series_no || "");
      setNarration(entry.narration || "");
      setCurrency(entry.currency || { value: "QAR", label: "QAR" });

      setReference(
        entry.reference
          ? entry.reference.map(ref => ({ value: ref, label: ref }))
          : []
      );

      setBillNo(entry.bill_no || "");
      setBillDate(entry.bill_date || currentDate);

      setEntries(
        entry.data.map(e => ({
          glAccount:Number(e.ledger_id),
          description: e.description || "",
          debit: e.debit || "",
          credit: e.credit || "",
        }))
      );

    } catch (err) {
      console.error("Error loading form data:", err);
    }
  };

  useEffect(() => {
    loadFormData();
  }, []);

  const addRow = () => {
    setEntries([
      ...entries,
      { glAccount: null, description: "", debit: "", credit: "" },
    ]);
  };

  const removeRow = (indexToRemove) => {
    setEntries(entries.filter((_, i) => i !== indexToRemove));
  };

  const handleEntryChange = (index, field, value) => {
    const updatedEntries = [...entries];
    updatedEntries[index][field] = value;
    setEntries(updatedEntries);

    if (field === "debit") updatedEntries[index].credit = 0;
    else if (field === "credit") updatedEntries[index].debit = 0;
  };

  const addGlAccount = (newAccount) => {
    const option = {
      value: newAccount.code,
      label: `${newAccount.code} - ${newAccount.name}`,
    };
    setGlAccounts((prev) => [...prev, option]);
    return option;
  };

  /* const totalDebit = entries.reduce(
    (acc, entry) => acc + parseFloat(entry.debit || 0),
    0
  );
  const totalCredit = entries.reduce(
    (acc, entry) => acc + parseFloat(entry.credit || 0),
    0
  );  */
  
  // Calculate totals
  const totalDebit = entries.reduce((sum, r) => sum + Number(r.debit || 0), 0);
  const totalCredit = entries.reduce((sum, r) => sum + Number(r.credit || 0), 0);

  const isBalanced = totalDebit === totalCredit && totalDebit > 0;
  const hasMinRows = entries.length >= 2;

  const hasRequiredFields = voucherDate && series_no && narration.trim() !== "";

  let allEntriesValid = entries.every((entry) => entry.glAccount !== null);

  let editReasonRequired = entry !== null;
  if (editReasonRequired && editReason.trim() === "") {
    allEntriesValid = false;
  }

  const canSubmit = isBalanced && hasMinRows && hasRequiredFields && allEntriesValid;

  return (
      <>
        {errorMsg && (
          <div className="alert alert-danger py-2">
            {errorMsg}
          </div>
        )}
        <form>
          <div className="row mb-3">
            {/* Date */}
              <div className="col-md-3">
                <label className="form-label fw-bold">Date*</label>
                <input
                  type="date"
                  className="form-control"
                  value={voucherDate}
                  onChange={(e) => setVoucherDate(e.target.value)}
                  required
                />
              </div>

              {/* Series No */}
            <div className="col-md-3">
              <label className="form-label fw-bold">Reference No.</label>
              <input type="text"
                      className="form-control" 
                      value={series_no}
                      onChange={(e) => setSeries_no(e.target.value)} readOnly />
            </div>
          </div>

          {/* Table for Debit/Credit */}
          <div className="table mb-1"> {/* table-responsive  */}
            <table className="table table-bordered" id="entryTable">
              <thead>
                <tr>
                  <th width="25%">GL Account*</th>
                  <th width="35%">Description</th>
                  <th className="text-end pe-2">Debit*</th>
                  <th className="text-end pe-2">Credit*</th>
                  <th className="text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((entry, index) => (
                  <tr key={index}>
                    <td style={{ display: "flex", gap: "5px" }}>
                      <SearchableSelect
                          value={entry.glAccount}
                          onChange={(val) => handleEntryChange(index, "glAccount", val)}
                          options={glAccounts ?? []}
                          placeholder="Type or select..."
                      />

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => {
                          setActiveRowIndex(index);   // ✅ store row index
                          setShowGlModal(true);
                        }}
                      >
                        +
                      </button>
                    </td>
                    <td>
                      <textarea
                        className="form-control"
                        placeholder="Description here..."
                        value={entry.description}
                        onChange={(e) =>
                          handleEntryChange(index, "description", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control text-end"
                        value={entry.debit}
                        onChange={(e) =>
                          handleEntryChange(index, "debit", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control text-end"
                        value={entry.credit}
                        onChange={(e) =>
                          handleEntryChange(index, "credit", e.target.value)
                        }
                      />
                    </td>
                    <td className="text-end pe-4">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removeRow(index)}
                        disabled={entries.length === 1}
                      >
                        x
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Debit Total & Credit Total column */}
          <div className="row mb-3">
            <div className="col-md-7 text-end fw-bold">Totals:</div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control text-end"
                value={totalDebit.toFixed(2)}
                readOnly
              />  
            </div>
            <div className="col-md-2">
              <input
                type="text"
                className="form-control text-end"
                value={totalCredit.toFixed(2)}  
                readOnly
              />
            </div>
          </div>  
          
          {/* Balance Summary */}
          <div className="row mb-3 align-items-center">
            <div className="col-md-8 text-end">
              <label className="form-label fw-bold">Balance:</label>
            </div>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control text-end"
                value={(totalDebit - totalCredit).toFixed(2)}
                readOnly
              />
            </div>
            <div className="col-md-1 text-end">
              <button
                type="button"
                className="btn btn-info btn-sm"
                onClick={addRow}
              >
                +
              </button>
            </div>
          </div>

          <div className="form-text mb-2 text-danger text-end pe-5">
            {!isBalanced &&<small>Debit and Credit must balance.</small>}
            {!allEntriesValid && <small> All GL Accounts must be selected.</small>}
          </div>

          {/* Additional Fields */}
            <div className="row mb-4">
              <div className="col-12 col-md-6">
                <label htmlFor="narration" className="form-label">
                  Narration*
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  value={narration}
                  onChange={(e) => setNarration(e.target.value)}
                  required
                ></textarea>
              </div>
              {entry && (
                <div className="col-12 col-md-6">
                  <label htmlFor="editReason" className="form-label text-danger">
                    Edit Reason*
                  </label>
                  <textarea
                    className="form-control"
                    rows="5"
                    value={editReason}
                    onChange={(e) => setEditReason(e.target.value)}
                    required
                  ></textarea>
                </div>
              )}
            </div>
            <h5 className="mb-3 mt-3">Additional Data</h5>
            <div className="row mb-3">
              <div className="col-12 col-md-3">
                <label className="form-label">Segment</label>
                <SearchableSelect
                  value={segment}
                  onChange={(val) => setSegment(val)}
                  options={loadSegments ?? []}
                  placeholder="Choose..."
                />
              </div>

              <div className="col-12 col-md-3">
                <label className="form-label">Currency</label>
                <SearchableSelect
                  value={currency}
                  options={[
                    { value: "QAR", label: "QAR" },
                    { value: "OMR", label: "OMR" },
                    { value: "AED", label: "AED" },
                    { value: "USD", label: "USD" },
                  ]}                  
                  onChange={(val) => setCurrency(val)}
                  placeholder="Choose..."
                />
              </div>

              {/* Reference */}
            <div className="col-md-3">
              <label className="form-label">Adjustable Invoices (if any)</label>
              <SearchableSelect
                options={reference}
                value={reference}
                isClearable
                ismulti={true}
                onChange={(e) => setReference(e)}
                placeholder="Choose..."
              />
            </div>
          </div>

          <div className="row mb-4">

            <div className="col-12 col-md-2">
              <label className="form-label">Bill No.</label>
              <input
                type="text"
                className="form-control"
                value={billNo}
                onChange={(e) => setBillNo(e.target.value)}
              />
            </div>

            <div className="col-12 col-md-2">
              <label className="form-label">Bill Date</label>
              <input
                type="date"
                className="form-control"
                value={billDate}
                onChange={(e) => setBillDate(e.target.value)}
              />
            </div>
          </div>

          {/* Submit Buttons */}
          <div className="col-12 mb-3 text-end">
            <button
              className="btn btn-primary me-2"
              type="button"
              disabled={!canSubmit}
              onClick={() => {
                const finalData = {
                  voucher_date: voucherDate,
                  series_no,
                  entries,
                  narration,
                  segment,
                  currency,
                  bill_no: billNo,
                  bill_date: billDate,
                  reference: (''!=reference) ? reference.map((ref) => ref.value) : null,
                  edit_reason: editReason ?? '',
                };
                onSubmit(finalData, entry?.id ?? null);
              }}
            >
              Submit
            </button>
            <button className="btn btn-secondary me-2" type="reset">
              Reset
            </button>
            <button className="btn btn-secondary" onClick={() => window.closePanel()}>
              Cancel
            </button>
          </div>

          {/* Modal */}
          {showGlModal && (
            <AddGlModal
              onClose={() => {
                setShowGlModal(false);
                setActiveRowIndex(null);
              }}
              onSave={(newLedger) => {
                const option = {
                  value: newLedger.id,
                  label: `${newLedger.ledger_code} - ${newLedger.ledger_name}`,
                };

                // 1️⃣ Add to dropdown options
                setGlAccounts((prev) => [...prev, option]);

                // 2️⃣ Auto-select ONLY the clicked row
                setEntries((prev) => {
                  if (activeRowIndex === null) return prev;

                  const updated = [...prev];
                  updated[activeRowIndex] = {
                    ...updated[activeRowIndex],
                    glAccount: option,
                  };
                  return updated;
                });

                // 3️⃣ Cleanup
                setShowGlModal(false);
                setActiveRowIndex(null);
              }}
            />
          )}

        </form>
    </>
  );
}

export default TransactionForm;
